
export interface Document {
  document_name: string;
  section_name: string;
  html: string;
  indent: number;
  index: number;
}

export enum DocumentId {
  PrivacyPolicy = 1,
  ProfessionalFeeAgreement = 2,
  TermsOfBusiness = 3,
  CookiesPolicy = 4,
  DebitOrderAuthority = 5,
  BrokerAppointment = 6
}